import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';
import { useSelector } from 'react-redux';
import { denormalizeAssetData } from '../../util/data';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = () => {
  let { footer = {}, topbar } = useConfiguration();

  const locale = useSelector(state => state.ui.locale);
  const currentUser = useSelector(state => state.user?.currentUser);
  const userLocale = currentUser?.attributes?.profile?.privateData?.language;
  const localStorageLocale =
    typeof window !== 'undefined' ? localStorage.getItem('language') : null;
  const localeValue = userLocale || localStorageLocale || locale;

  let localData = null;

  try {
    localData = require(`../../assets/content/pages/${localeValue}/footer.json`);
    const data = { data: localData.data[0]?.attributes?.data };
    footer = denormalizeAssetData(data);
  } catch (e) {}

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  return <SectionBuilder sections={[footerSection]} />;
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
